import React from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";

import "./MessagesBlankState.scss";

const MessagesBlankState = ({ link, image, title, text }) => (
	<a className="messages-blankstate" href={link}>
		{image && (
			<img className="messages-blankstate-image" src={image} alt={title} />
		)}
		<div className="messages-blankstate-title">
			{title}
		</div>
		<div className="messages-blankstate-text">
			{text}
		</div>
	</a>
);

MessagesBlankState.propTypes = {
	link: PropTypes.string,
	image: PropTypes.string,
	title: PropTypes.string,
	text: PropTypes.string,
};

MessagesBlankState.defaultProps = {
	link: "/doubletake?clear_history=1",
	image: null,
	title: _str("None right now."),
	text: "",
};

export default MessagesBlankState;



// WEBPACK FOOTER //
// ./src/apps/messages/components/MessagesBlankState.jsx